import { useEffect, useReducer } from "react";
import { HbrAvatarProfile } from "./Mycustomsvgicons";
import { useLocation, useNavigate } from "react-router-dom";
import { actionConsts, reducer } from "./StateManager";
import { DisplayUserPicAndName } from "./GeneralClasses";


const DivineShorts = ({shorts_id,shorts_thumbnail,shorts_email}) => {

    const [state,dispatch]=useReducer(reducer,{progressIndicator: false, alertMessage: "", showAlert: false, userNameToDisplay: "", userProfilePic: ""});
    const navigate = useNavigate();
    const location = useLocation();
  
    useEffect(()=>{
        async function getUserInfo() {
            const userInfo = await DisplayUserPicAndName(shorts_email);
            if (userInfo) {
                dispatch({type: actionConsts.USER_PICTURE, payload: userInfo.profilePic});
            };
        }
        getUserInfo();
    },[shorts_email]);


    return  ( 
        <div className="divineshorts">
            <img id="shortsThumb" 
            src={shorts_thumbnail} 
            alt="shorts thumbnail" 
            onClick={()=>navigate(`/divineshorts/${shorts_id}`,{state: {from: location.pathname}})}/>
            
            <div className="shortsProfile" style={{borderRadius:"50%"}}>
                {state.userProfilePic !== "" ? (<img src={state.userProfilePic} alt=""/>) : (<HbrAvatarProfile width={"2em"} height={"2em"} />)}
            </div>
           
        </div>
     );
}
export default DivineShorts;